export default {
    parent: 'ApplicationLayout',
    template: `
        <div class="col00 small">
            <ui-view class="body-wrapper "></ui-view>
        </div>
        <footer class="footer-wrapper"></footer>
    `
};



// WEBPACK FOOTER //
// ./src/app/layouts/feedback/index.js